import React from 'react';
import { Router, Route, browserHistory } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';
import CounsellingPage from '../components/CounsellingPage';

function RouterConfig(props) {
  return (
    <Router history={props.history}>
      <LocaleProvider locale={ja_JP}>
        <Route path="/school" render={() => <CounsellingPage appKey={props.app.appkey} />} />
      </LocaleProvider>
    </Router>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/school/config/router.js